@if (loading) {
	<loading></loading>
} @else {
	<div class="view-container">
		<router-outlet></router-outlet>
	</div>

	<!-- Google Tag Manager (noscript) -->
	<noscript>
		<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-N4QTLV4" height="0" width="0"
			style="display:none;visibility:hidden">
		</iframe>
	</noscript>
	<!-- End Google Tag Manager (noscript) -->

	<!-- Go Toast Component -->
	<ngx-go-toast></ngx-go-toast>
}
